<template>
  <div class="address-wrapper">
    <van-address-edit
      :area-list="areaList"
      :search-result="searchResult"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
      save-button-text="确认收货信息"
    />
  </div>
</template>

<script>
import areaList from "@/assets/js/area.js";
import { rewardPointGoodsExchange } from "@/api/user";

export default {
  name: "GoodsDetail",
  data() {
    return {
      areaList,
      searchResult: [],
      commitInfo: {},
    };
  },
  methods: {
    onSave(content) {
      console.log(content);
      this.commitInfo = content;
      this.request_rewardPointGoodsExchange();
    },

    //============net=============
    request_rewardPointGoodsExchange() {
      const rewardPointGoodsId = this.$route.query.rewardPointGoodsId;
      let params = {
        consigneeAddress: `${this.commitInfo.province}${this.commitInfo.city}${this.commitInfo.county}${this.commitInfo.addressDetail}`,
        consigneeMobilePhone: this.commitInfo.tel,
        consigneeName: this.commitInfo.name,
        rewardPointGoodsId,
      };

      rewardPointGoodsExchange(params).then((res) => {
        if (res.code == 0) {
          this.$router.push({ path: "/changeSuccess" });
        } else {
          this.$toast({
            message: res.msg,
            duration: 1000,
          });
        }
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.address-wrapper {
  box-sizing: border-box;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  padding-bottom: 1.3rem;

  & >>> .van-button--danger {
    background-color: #5597EC;
    border: 1px solid #5597EC;
  }
}
</style>



// WEBPACK FOOTER //
// app/pages/tabs/Mine/AddressInfo.vue